export default __webpack_public_path__ + "static/media/profileReviews@2x.56a1bf67.png";